import React from "react";

interface ITextSentimentModelInputProps {
  showUserInputsOnly: boolean;
}

class TextSentimentModelInput extends React.Component<ITextSentimentModelInputProps, {}> {
  constructor(props: ITextSentimentModelInputProps) {
    super(props);
  }

  public validateForm = () => {
    return true;
  };

  public getFormData = (modelNamePrefix: string) => {
    const formData = new FormData();
    formData.append(`${modelNamePrefix}.LanguageCode`, 'en');
    return formData;
  }

  public resetForm = () => {
    /* tslint:disable:no-empty */
  };

  public render() {
    return <></>;
  }
}

export default TextSentimentModelInput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/input/TextSentiment/TextSentimentModelInput.tsx